import React, { Component, Fragment } from "react"
import { connect } from "react-redux";
import styled, { css, keyframes } from 'styled-components'
import Link, { navigateTo, push } from "gatsby-link"
import { find, filter } from 'lodash'
import VisibilitySensor from 'react-visibility-sensor'
import { VelocityComponent } from 'velocity-react'
import { Parallax } from 'react-scroll-parallax';
import Masonry from 'react-masonry-component';
import PageTransition from 'gatsby-plugin-page-transitions';
import { Header, InstagramFeed, PostMeta, SignupForm } from "../components";
import { data } from '../data/home'

import signupLogo from '../assets/images/mambo-logo-signup.svg'
import newRange from '../assets/images/home-new-range.png'
import banner from '../assets/images/instagram-banner.png'

import { fetchSettings, getSettings, updateSettings } from '../store/settings';

import { container, heading, bgImage, button, bgIcon, hoverState, padding } from "../styles/global"
import { resolveHeaderType } from "../styles/fonts";
import { width, media } from "../styles/utils";
import { injectGlobal } from "emotion";
import { rgba } from "polished";

class Home extends Component {

	state = {
		visiblePosts: [],
        activeCategory: 'all'
	}

	componentDidMount = () => {
        const posts = this.props.data.allWordpressArticles.edges;
		const homeData = this.props.data.wordpressHome;
        
		this.setState({
            posts: posts,
			homeData: homeData,
			activeCategory: this.props.pathContext.mainSection || 'all'
		})
	}

	getPosts = () => {
		const { posts, activeCategory} = this.state;

		if (!posts) return;

		if (activeCategory !== 'all') {
			return filter(posts, { node: { mainSection: activeCategory }})
		} else {
			return posts
		}
	}
	
	parallaxOptions = (i) => {
		return ({
			offsetYMax: 0,
			offsetYMin: i !== 0 ? '-50%' : '0',
			disabled: width.phone() ? true : false,
			styleInner: {
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center'
			}
		})
	}
	
	handleVisiblity = (isVisible, i, section) => {		
		const currentState = this.state.visiblePosts[`post${section}${i}`];

		if (isVisible && isVisible !== currentState) {
			this.setState({
				visiblePosts: {
					...this.state.visiblePosts,
					[`post${section}${i}`]: isVisible
				}
			})
		}
	}

	handleCategoryChange = (category) => {
		this.setState({
			activeCategory: category,
			visiblePosts: []
		})

		window.history.replaceState(null, null, `/articles/${category}`);
	}

	renderCategories = () => {
		const { activeCategory } = this.state;

		// Insert 'all' at index 0 

		let cats = [
			{
				slug: 'all',
				name: 'All'
			},
			...data.categories
		]

		const categories = cats.map((cat, i) => {
			return (
				<Category
					onClick={() => this.handleCategoryChange(cat.slug)}
					active={activeCategory == cat.slug}
				>
					{cat.name}
				</Category>
			)
		})

		return (
			<Categories>
				{categories}
			</Categories>
		)
	}

	renderPromoBox = () => {
        const { homeData } = this.state;

        if (homeData && homeData.promo.display) {
            return (
                <FloatingWrapper>
                    <Promo
						image={homeData.promo.promo_image.source_url}
					>
                        <Image/>
                        <Button
							href={homeData.promo.link}
							target={'_blank'}
                        >
                            {homeData.promo.link_text}
                        </Button>
                    </Promo>
                </FloatingWrapper>
            )
        }
	}

	renderSignup = () => {
		return (
			<FloatingWrapper>
				<Signup>
					<Heading>The latest from</Heading>
					<Logo/>
					<Button
                        onClick={this.toggleSignup}
                    >
						Sign up
					</Button>
				</Signup>
			</FloatingWrapper>
		)
    }
    
    toggleSignup = () => {
		const { updateSettings } = this.props;

		updateSettings({
			signupActive: true
		})
	}

	renderFeatured = () => {
        const { homeData, activeCategory } = this.state;

        if (homeData) {
            const catData = find(homeData.selected_categories,{'category': activeCategory});
            const featured = catData.heroArticle;

            return (
                <PostLink
                    to={`/article/${featured.post.post_name}`}
                >
                    <Featured
                        image={featured.acf.hero_image.sizes.xlarge}
                        theme={featured.theme}
                    >
                        <Heading
                            dangerouslySetInnerHTML={{__html: featured.post.post_title}}
                        />

                        <PostMeta
                            post={featured}
                        />

						<Overlay/>
                    </Featured>
                </PostLink>
            )
        }		
	}
	
	visibleOnLoad = (i, section) => {

		// Check if post should be visible on load

		if (section == 'top' && (i == 0 || i == 1)) {
			return true
		}
	}

	wrapAnimation = (component, i, section) => {
		const isVisible = this.visibleOnLoad(i, section) || this.state.visiblePosts[`post${section}${i}`] || false;

		return (
			<VisibilitySensor
				onChange={(isVisible) => this.handleVisiblity(isVisible, i, section)}
				scrollDelay={1}
				delayedCall={true}
				partialVisibility={{
					top: 0
				}}
				offset={{
					bottom: -200
				}}
				minTopValue={0}
			>
				<VelocityComponent
					// runOnMount={true}
					animation={{ 
						opacity: isVisible ? 1 : 0,
						translateY: isVisible ? 0 : 300,
						// translateX: isVisible ? 0 : i % 2 ? -20 : 20,
						// rotateZ: isVisible ? '-3deg' : '-2deg',
					}}
					duration={650}
					easing={'easeOutCubic'}
				>
					{component}
				</VelocityComponent>
			</VisibilitySensor>
		)
	}

	renderFeaturedMobile = () => {
		const { homeData, activeCategory } = this.state;

		if (homeData) {
			const catData = find(homeData.selected_categories, {'category': activeCategory});
			const post = catData.heroArticle;
			//console.log(post)
			const featured = {
				...post,
				slug: post.post.post_name,
				title: post.post.post_title,
				acf: post.acf,
			};
			
			//console.log(featured)
			return this.renderPost(featured)
		}
	}

	navigateToPost = (slug) => {
		navigateTo(`/article/${slug}`)
	}	

	renderPost = (post, i, totalPosts) => {
		return (	
			<Post
				key={i}
				className="grid-item"
				lastItem={i + 1 == totalPosts}
				type={post.acf.title_style}
				width={post.acf.post_width}
			>
				<PostLink
					to={`/article/${post.slug}`}
				>
					<Parallax
						{...this.parallaxOptions(i)}
					>
						<Img
					        src={post.acf.hero_image && post.acf.hero_image.sizes.medium2 || post.acf.hero_image.sizes.xlarge}
						/>
			
						<Info>
							<Heading
								dangerouslySetInnerHTML={{__html: post.title}}
							/>

							<PostMeta
								post={{
									...post,
									theme: 'dark'
								}}
							/>
						</Info>
					</Parallax>
				</PostLink>
			</Post>
		)
	}

	renderPosts = (data, inject, section, category) => {

		// Inject component at index if available

		if (inject) {
			data.splice(inject.index, 0, inject.component)
		}

		// Loop over posts (and injected comps) and wrap animation

		const posts = data.map((post, i) => {
			if (post && post.node && post.node.title) {
				return this.wrapAnimation(this.renderPost(post.node, i, data.length), i, section)
			} else {
				return this.wrapAnimation(post, i, section)
			}
		})
		
		if (width.phone()) {
			return (
				<Posts>
					{posts}
				</Posts>
			)
		} else {
			return (
				<Posts>
					<Masonry 
						options={{
							transitionDuration: 0,
							gutter: width.tablet() ? 38 : 90,
						}}
						style={{
							width: '100%'
						}}
					>
						{posts}
					</Masonry>
				</Posts>
			)
		}						
	}
	
  	render() {
        const { splashData, activeCategory, signupOpen } = this.state;
        const posts = this.getPosts();
    
		return (
			<PageTransition>
				<Wrapper>

					{/* Categories */}

					<Container>
						{this.renderCategories()}
					</Container>

					{/* Top Posts */}

					<Container>
						{width.phone() ? this.renderFeaturedMobile() : this.renderFeatured()}

						{posts && this.renderPosts(
							posts.slice(0, posts.lenth >= 4 ? post.length : 4), 
							{
								component: this.renderSignup(),
								index: 1,
							},
							'top',
							activeCategory
						)}
					</Container>

					{/* Instagram */}

					<InstagramFeed />

					{/* Remaining Posts */}

					<Container>
						{posts && posts.length > 4 && this.renderPosts(
							posts.slice(4), 
							{
								component: this.renderPromoBox(),
								index: 1,
							},
							'bottom',
							activeCategory
						)}
					</Container> 

				</Wrapper>
			</PageTransition>
		)	
  	}
}

const Wrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;	
	width: 100%;
	color: black;	

`

export const Container = styled.div`
    ${container}
	flex-direction: column;
	${padding};
	flex: 1;
`

// Shared

export const Heading = styled.div`
	${heading}
`
const Description = styled.div``
const Button = styled.a`
    color: black;
`
export const Img = styled.img``
const Image = styled.div`
	background-image: url(${props => props.image});
	${bgImage}
`

// Categories

const Categories = styled.div`
	display: flex;
	justify-content: center;
	margin-bottom: 64px;

	${media.phone`
		margin-bottom: 40px;
	`}
`

const Category = styled.div`
	padding: 0 10px;
	height: 50px;
	width: 130px;
	box-sizing: border-box;
	display: flex;
	justify-content: center;
	align-items: center;
	font-family: 'Dot Stick';
	font-size: 10px;
	line-height: 40px;
	cursor: pointer;
	user-select: none;
	
	&:not(:last-child) {
		margin-right: 15px;

		${media.phone`
			margin-right: 0;
		`}
	}

	${props => {
		if (props.active) return css`
			border: 2px solid #000000;
		`
	}}

	&:hover {
		border: 2px solid #000000;
	}

	${media.phone`
		margin-right: 0;
		width: auto;
		flex: 1;
		font-size: 7px;
		height: 40px;	
	`}
`

// Featured

const Featured = styled.div`
	border: 2px solid black;
	width: 100%;
	height: 600px;
	box-sizing: border-box;
	
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	position: relative;

	background-image: url(${props => props.image});
	${bgImage}

	${Heading} {
		font-family: 'GT America Condensed Bold';
		font-size: 45px;
		line-height: 45px;
		text-transform: uppercase;
		text-align: center;
		max-width: 540px;
		margin-bottom: 23px;
	}

	${props => {
		if (props.theme == 'light') return css`
			color: white;
		`
	}}

	/* Hover */

	> *:nth-child(1),
	> *:nth-child(2) {
		transition: opacity 0.15s ease;
		z-index: 2;
	}

	&:hover {
		> *:nth-child(1),
		> *:nth-child(2) {
			opacity: 0.25;
		}
	}
`

const Overlay = styled.div`
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	background: ${rgba('black', 0.3)};
	z-index: 1;
`

// Post

export const Posts = styled.div`
	display: flex;	
	flex-direction: column;
	flex-flow: row wrap;
	justify-content: space-between;
	margin-top: 80px;

	${media.phone`
		margin-top: 0;
	`}
`

export const PostLink = styled(Link)`
	color: black;
`

export const gridItem = css`
	width: calc(50% - 45px);
	margin-bottom: 350px;

	${media.tablet`
		width: calc(50% - 19px);	
	`}

	${media.phone`
		width: 100%;
		margin-bottom: 60px;
	`}

	${props => {
		if (props.lastItem) return css`
			margin-bottom: 60px;
		`
	}}
`

const floatingBox = css`
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-left: auto;

	border: 2px solid #000000;
	box-shadow: 10px 10px 0 0 #000000;
	box-sizing: border-box;
	transform: translateX(-20px); 

	min-height: 250px;

	${Button} {
		font-family: 'GT America Expanded Bold';
		font-size: 20px;
		text-align: center;
		line-height: 62px;
		text-transform: uppercase;

		height: 60px;
		border-top: 2px solid black;
		width: 100%;

		${hoverState}
	}

	transition: all 0.15s ease-out;

	&:hover {
		transition: all 0.25s ease;
	}

	${media.tablet`
		min-height: 0;
		margin-right: auto;
		transform: translateX(-5px); 
		box-shadow: 6px 6px 0 0 #000000;

		${Button} {
			font-size: 15px;
			height: 50px;
			line-height: 50px;
		}
	`}
	
	
	${media.phone`
		max-width: 260px;
	`}
	
`

const FloatingWrapper = styled.div`
	${gridItem}
`

export const Post = styled(Link)`
	${gridItem}
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: black;
	will-change: transform;

	${Img} {
		border: 2px solid black;
		height: auto;
		width: auto;
		max-width: 100%;
		max-height: 570px;
		box-sizing: border-box;
	}

	${Heading} {
		font-family: 'GT America Condensed Bold';
		font-size: 45px;
		line-height: 45px;
		text-transform: uppercase;
		text-align: center;
		max-width: 540px;
		margin-top: 25px;
		margin-bottom: 23px;
	    ${props => resolveHeaderType(props.type)}

		${media.phone`
			font-size: 28px;
			line-height: 30px;
			margin-top: 12px;
			margin-bottom: 10px;
		`}
	}



	/* Post Width */

	${props => {
		if (props.width == 'small') return css`
			${Img} {
				width: 420px;
				max-width: 100%;
			}
		`

		if (props.width == 'medium') return css`
			${Img} {
				width: 480px;
				max-width: 100%;
			}
		`

		if (props.width == 'large') return css`
			${Img} {
				width: 540px;
				max-width: 100%;
			}
		`
	}}

`

export const Info = styled.div`
	transition: opacity 0.15s ease;
	will-change: opacity;

	&:hover {
		opacity: 0.5;
	}
`

// Sign up

const Logo = styled.div``

const Signup = styled.div`
	${floatingBox}
	max-width: 480px;

	${Heading} {
		font-family: 'Dot Stick';
		font-size: 16px;
		text-align: center;
		line-height: 62px;
		margin-top: 26px;
	}

	${Logo} {
		background-image: url(${signupLogo});
		${bgIcon}
		max-width: 409px;
		height: 60px;
		margin-bottom: auto;
		width: calc(100% - 24px);
		padding: 0 24px;
		box-sizing: border-box;
	}

	${media.tablet`
		${Heading} {
		    font-size: 9px;
			line-height: 36px;
			margin-top: 15px;
		}

		${Logo} {
			max-width: 235px;
			height: 35px;
			margin-bottom: 24px;
			width: 100%;
		}
	`}

	&:hover {
		box-shadow: 20px 20px 0 0 #000000;
		transform: translate(-20px, -10px); 
	}
`

// New Range

const Promo = styled.div`
	${floatingBox}
	max-width: 420px;
	margin-top: 350px;
	transform: translateX(-60px); 

	${Image} {
		background-image: url(${props => props.image});
		${bgIcon}
		max-width: calc(100% - (38px * 2));
		width: 100%;
		height: 276px;
		margin: 38px;
	}


	${Heading} {
		font-family: 'Dot Stick';
		font-size: 22px;
		text-align: center;
		line-height: 53px;
		margin-top: 26px;
		max-width: 382px;
		margin-bottom: auto;
		margin-bottom: 29px;
	}

	${media.phone`
		max-width: 260px;
		margin: 0 auto;
		transform: translateX(5px);

		${Image} {
			height: 224px;
			width: 180px;
			margin-top: 12px;
		}

		${Heading} {
			font-size: 13px;
			line-height: 33px;
			margin-bottom: 12px;
		}
	`}

	&:hover {
		box-shadow: 20px 20px 0 0 #000000;
		transform: translate(-60px, -10px); 
	}
`


const mapDispatchToProps = dispatch => ({
    fetchSettings() {
        dispatch(fetchSettings())
    },
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
})

const mapStateToProps = (state, props) => ({
    settings: state.settings.settings
})

export default connect(mapStateToProps, mapDispatchToProps)(Home);

export const pageQuery = graphql`
    query Home {
		allWordpressArticles {
            edges {
                node {
                    title
                    slug
                    publishedDate
                    mainSection
					sections {
						... on sections_4 {
							name
							slug 
							isSub           
						}
					}
					tags {
						... on tags_2 {
							name
							slug
						}
					}
                    acf {
                        byline
						author
						title_style
                        post_width
                        hero_image {
                            sizes {
                                medium2
                            }
                        }
                    }
                }
            }
        }

        wordpressHome {

            promo {
                display
                link_text
                link
                promo_image {
                    source_url
                } 
            }

            selected_categories{
                ... on selectedCategories_6{
                    category
                    heroArticle {
                        publishedDate
                        theme
                        post {
                            post_title
                            post_name
                        }
                        acf {
                            title_style
                            author
                            photographer
                            hero_image {
                                sizes {
                                    xlarge
                                }
                            }
                        }
                        sections {
                            slug
                            name
                            isSub
                        }
                        mainSection
                    }  
                }
            }
        }
        
    }
`



// WEBPACK FOOTER //
// ./src/pages/index.js